import React from "react";
import './SearchResultsSummary.scss';

const SearchResultsSummary = ({ facilities, totalResults, searchParams }) => {
  const offset = searchParams.has('offset') ? parseInt(searchParams.get('offset')) : 0;
  return (
    <div className="SearchResultsSummary">
      Showing {offset + 1} - {offset + facilities.length} of {totalResults} assisted living care {totalResults !== 1 ? 'facilities' : 'facility'}
    </div>
  );
};

export default SearchResultsSummary;
